/* global $, API */

const SEARCH_CLASS = '.js-media-search';
const LIST_CLASS = '.js-media-list';
const SIDEBAR_CLASS = '.js-media-sidebar';
const PAGE_CLASS = '.js-media-page';
const SPINNER_HTML = '<div class="spinner"></div>';

const Filter = {
  create(node, options) {
    this.node = node;
    this.options = options;

    // Get the media list
    this.$list = $(this.node).find(LIST_CLASS);

    // Run the filter on load
    this.runFilter()
      .then(() => {
        window.pubsub.publish('media:loaded');
      });

    // Listen for media filter calls
    window.pubsub.subscribe('media:filter', () => {
      this.runFilter()
        .then(() => {
          window.pubsub.publish('media:loaded');
        });
    });
  },

  /**
   * Run the media filter
   * @return {Promise}
   */
  runFilter() {
    // Get selected options in the UI
    const params = this.getSelectedOptions();

    // Show spinner while loading
    this.$list.html(SPINNER_HTML);

    // Make the request and output on complete
    return this.makeRequest(params)
      .then(output => this.outputList(output.data));
  },

  /**
   * Get the selected filters in the UI
   * @return {Object}
   */
  getSelectedOptions() {
    // Get all selected folder checkboxes
    const $sidebarChecks = $(SIDEBAR_CLASS).find('input:checked');

    // Get all selected folders values
    const folders = $sidebarChecks.toArray().map(check => check.value);

    // Get the search value
    const search = $(SEARCH_CLASS).val();

    const page = parseInt($(PAGE_CLASS).val(), 10);

    return {
      folders,
      search,
      page,
    };
  },

  /**
   * Make a request to the back-end for a list of media items
   * @param {Object} obj
   * @return {Promise}
   */
  makeRequest(obj) {
    return window.axios.post(API.media.listUrl, obj)
      .catch((err) => {
        console.error(err); // eslint-disable-line
      });
  },

  /**
   * Output media items to the DOM
   * @param {String} output
   * @return {Void}
   */
  outputList(output) {
    this.$list.html(output);
    this.$list.trigger('media:filtered');
    this.removeSpinners();
  },

  removeSpinners() {
    let media = document.querySelectorAll('.js-media-thumb');
    media = Array.prototype.slice.call(media);

    media.forEach((element) => {
      const spinner = element.parentElement.querySelector('.js-spinner');

      element.addEventListener('load', () => {
        spinner.remove();
      });
    });
  },
};

export default Filter;
